
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

export class AppConstants {
  static TASK_LANGUAGE = "taskLanguage";
  static SQLITE_SYNC_DELAY = 3;
  static TASKS_SYNC_LIMIT_SERVER = 50;
  static TASKS_LIMIT = 25;
  static OFFLINE_TASK_LAST_SYNC_TIMESTAMP = "offline_task_last_sync_timestamp";
  static TASK_DARK_MODE = "dark_mode";
  static OFFICE_PREVIEW = "office_preview";
}
